import React from "react";
import BrowsersOSPieChart from "./BrowsersOSPieChart";
import BrowsersTypePieChart from "./BrowsersTypePieChart";
import BrowsersSystemPieChart from "./BrowsersSystemPieChart";

export default function BrowserData() {
  return (
    <div className="d-flex flex-column flex-lg-row justify-content-lg-around pb-2">
      <BrowsersOSPieChart />
      <BrowsersTypePieChart />
      <BrowsersSystemPieChart />
    </div>
  );
}
